import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "i-layout-header-trigger i-layout-header-trigger-min"
};
var _hoisted_2 = {
  key: 1,
  class: "i-layout-header-user-name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Avatar = _resolveComponent("Avatar");
  var _component_Icon = _resolveComponent("Icon");
  var _component_DropdownItem = _resolveComponent("DropdownItem");
  var _component_DropdownMenu = _resolveComponent("DropdownMenu");
  var _component_Dropdown = _resolveComponent("Dropdown");
  return _openBlock(), _createBlock(_component_Dropdown, {
    trigger: _ctx.isMobile ? 'click' : 'hover',
    class: _normalizeClass(["i-layout-header-user", {
      'i-layout-header-user-mobile': _ctx.isMobile
    }]),
    onOnClick: $options.handleClick
  }, {
    list: _withCtx(function () {
      return [_createVNode(_component_DropdownMenu, null, {
        default: _withCtx(function () {
          return [_createCommentVNode(" <i-link to=\"/setting/user\">\r\n                    <DropdownItem>\r\n                        <Icon type=\"ios-contact-outline\" />\r\n                        <span>{{ $t('basicLayout.user.center') }}</span>\r\n                    </DropdownItem>\r\n                </i-link>\r\n                <i-link to=\"/setting/account\">\r\n                    <DropdownItem>\r\n                        <Icon type=\"ios-settings-outline\" />\r\n                        <span>{{ $t('basicLayout.user.setting') }}</span>\r\n                    </DropdownItem>\r\n                </i-link> \r\n                <DropdownItem divided name=\"logout\">"), _createVNode(_component_DropdownItem, {
            name: "logout"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_Icon, {
                type: "ios-log-out"
              }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('basicLayout.user.logOut')), 1 /* TEXT */)];
            }),
            _: 1 /* STABLE */
          })];
        }),
        _: 1 /* STABLE */
      })];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("span", _hoisted_1, [_ctx.info.avatar ? (_openBlock(), _createBlock(_component_Avatar, {
        key: 0,
        size: "small",
        src: _ctx.info.avatar
      }, null, 8 /* PROPS */, ["src"])) : _createCommentVNode("v-if", true), !_ctx.isMobile ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.info.name), 1 /* TEXT */)) : _createCommentVNode("v-if", true)])];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["trigger", "class", "onOnClick"]);
}